import {
  type DownloadsByVersionDto,
  downloadsByVersionDto,
  type MetricsOverviewDto,
  type ModerationMetricsDto,
  metricsOverviewDto,
  moderationMetricsDto,
  type RevenueByPlanDto,
  revenueByPlanDto,
  type TimeseriesDto,
  timeseriesDto,
} from '@planuze/admin-contracts';
import { ApiError, parseJson, readErrorCode, request } from './http.js';

/* Cliente REST de métricas (28-15, ADR-0353/0359). Tudo read-only; o admin-service
   agrega via HMAC + cache 60s. Respostas validadas fail-closed; 502/503 (upstream/
   misconfigured) viram `server_error`. */

async function metricsError(res: Response): Promise<ApiError> {
  const code = await readErrorCode(res);
  return new ApiError(res.status, 'server_error', code || 'metrics request failed');
}

export async function getMetricsOverview(): Promise<MetricsOverviewDto> {
  const res = await request('/v1/admin/metrics/overview');
  if (!res.ok) throw await metricsError(res);
  return parseJson(res, metricsOverviewDto);
}

export async function getDownloadsByVersion(): Promise<DownloadsByVersionDto> {
  const res = await request('/v1/admin/metrics/downloads-by-version');
  if (!res.ok) throw await metricsError(res);
  return parseJson(res, downloadsByVersionDto);
}

/* Métricas de SLA da moderação (ADR-0463): dado local do admin, não cross-service. */
export async function getModerationMetrics(): Promise<ModerationMetricsDto> {
  const res = await request('/v1/admin/metrics/moderation');
  if (!res.ok) throw await metricsError(res);
  return parseJson(res, moderationMetricsDto);
}

export async function getRevenueByPlan(): Promise<RevenueByPlanDto> {
  const res = await request('/v1/admin/metrics/revenue-by-plan');
  if (!res.ok) throw await metricsError(res);
  return parseJson(res, revenueByPlanDto);
}

export interface TimeseriesParams {
  readonly from: string;
  readonly to: string;
  readonly grain: 'day' | 'week' | 'month';
}

/* Só `signups` existe no backend (MRR/churn timeseries deferidos — ADR-0353 §5). */
export async function getSignupsTimeseries(params: TimeseriesParams): Promise<TimeseriesDto> {
  const query = new URLSearchParams({
    metric: 'signups',
    from: params.from,
    to: params.to,
    grain: params.grain,
  });
  const res = await request(`/v1/admin/metrics/timeseries?${query.toString()}`);
  if (!res.ok) throw await metricsError(res);
  return parseJson(res, timeseriesDto);
}
